module.exports = __webpack_public_path__ + "static/stu_400-911513395fd01e3e4272cbd9bbb99a29.jpg";